import { debounce } from 'lodash'
import { setStore, getStore, removeStore } from '@utils/storage'
class ITSocket {
  socket
  callbacks = {}
  linsteners = ['open', 'error', 'close', 'message']
  option
  timeOut
  subscribeMap = {}
  reconnectTimes = 0
  constructor(option) {
    this.option = option
    this.startConnect(option)
    this.reconnectTimes = 5
  }

  startConnect(option = {}) {
    const { url, onConnected, onDisconnected, onConnectFailed } = option
    if (!url) {
      console.warn('URL is unlegal！')
      return
    }
    let deHeartBeat = debounce(this.startHeartBeat, 2000).bind(this)
    let deReconnect = debounce(this.reconnect, 3000).bind(this)
    this.callbacks['open'] = [deHeartBeat, onConnected]
    this.callbacks['error'] = [onConnectFailed, deReconnect]
    this.callbacks['close'] = [onDisconnected, deReconnect]
    this.callbacks['message'] = [deHeartBeat]
    try {
      this.socket = new WebSocket(url)
      this.addListener()
    } catch (error) {
      this.socket = {} // 处理链接失败后，socket为null
      setStore('socketError', error)
      onConnectFailed && onConnectFailed(error)
    }
  }
  reconnect() {
    this.socket = null
    if (this.reconnectTimes) {
      this.reconnectTimes--
      this.startConnect(this.option)
    }
  }
  startHeartBeat() {
    let self = this
    if (!this.isSocketOpen()) {
      return
    }
    Promise.race([
      this.promiseCreater(this.socket.send, 3000, '2'),
      this.promiseCreater(this.socket.close, 6000, 3000)
    ])
      .then(res => {
        res.fn.bind(self.socket)(res.message)
      })
      .catch(err => {
        console.log(err)
      })
  }

  promiseCreater(fn, delay, message) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          fn,
          message
        })
      }, delay)
    })
  }

  // 开启监听
  addListener() {
    let self = this
    this.linsteners.map(linsterKey => {
      self.socket.addEventListener(linsterKey, function(event) {
        self.listenerCallback(event, linsterKey)
      })
    })
  }
  listenerCallback(event, key) {
    try {
      this.consumeDefaultCallBack(event, key)
    } catch (err) {
      console.error(err)
    }
    if (key === 'message') {
      // 分发订阅
      let message = JSON.parse(event.data || '')
      let { data, channel } = message
      let fns = this.subscribeMap[channel]
      fns &&
        fns.map(fn => {
          fn({
            content: JSON.stringify({
              data
            })
          })
        })
    }
  }
  consumeDefaultCallBack(event, key) {
    let fns = this.callbacks[key]
    fns &&
      fns.map(fn => {
        fn && fn.bind(this, event)()
      })
  }
  isSocketOpen() {
    return this.socket && this.socket.readyState === WebSocket.OPEN
  }
  safeSend(payload) {
    if (!this.isSocketOpen()) {
      return false
    }
    try {
      this.socket.send(payload)
      return true
    } catch (error) {
      console.warn('WebSocket send skipped', error)
      return false
    }
  }
  subscribe({ channel, onMessage }) {
    if (!this.subscribeMap[channel]) {
      this.subscribeMap[channel] = []
    }
    this.subscribeMap[channel].push(onMessage)
    let subscrObj = {
      type: 'subscribe',
      body: {
        channels: [channel]
      }
    }

    this.safeSend(JSON.stringify(subscrObj))
  }
  unsubscribe(channel) {
    this.subscribeMap[channel] = []
    let unsubscrObj = {
      type: 'unSubscribe',
      body: {
        channels: [channel]
      }
    }
    this.safeSend(JSON.stringify(unsubscrObj))
  }
  publish({ channel, message }) {
    let fns = this.subscribeMap[channel]
    fns &&
      fns.map(fn => {
        fn({
          content: JSON.stringify({
            data: message
          })
        })
      })
  }
}
export default ITSocket
